export default function NoNetworkScreen() {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 flex flex-col items-center justify-center font-nunito"
      style={{
        background: 'linear-gradient(160deg, #FFF0F6 0%, #F5EEFF 50%, #FFF0F6 100%)',
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="flex flex-col items-center px-10 text-center">
        {/* 图标 */}
        <div
          className="w-24 h-24 rounded-3xl flex items-center justify-center mb-6"
          style={{ background: 'linear-gradient(135deg, #FFE4F0, #EDE9FF)' }}
        >
          <i className="ri-wifi-off-line text-5xl" style={{ color: '#C084FC' }}></i>
        </div>

        {/* 标题 */}
        <h2 className="text-xl font-bold text-gray-800 mb-2">
          {t('noNetwork_title', { defaultValue: '无网络连接' })}
        </h2>

        {/* 副标题 */}
        <p className="text-sm text-gray-400 leading-relaxed">
          {t('noNetwork_desc', { defaultValue: '请检查网络设置\n恢复连接后将自动刷新' })}
        </p>

        {/* 等待动画点 */}
        <div className="flex items-center gap-2 mt-8">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className="w-2 h-2 rounded-full animate-pulse"
              style={{
                background: 'linear-gradient(135deg, #FF6B9D, #A855F7)',
                animationDelay: `${i * 0.3}s`,
              }}
            />
          ))}
        </div>

        <p className="text-xs text-gray-300 mt-3">
          {t('noNetwork_waiting', { defaultValue: '正在等待网络...' })}
        </p>

        {/* 手动重试按钮 */}
        <button
          onClick={() => window.location.reload()}
          className="mt-8 px-8 py-3 rounded-2xl text-sm font-semibold text-white active:scale-95 transition-transform cursor-pointer"
          style={{ background: 'linear-gradient(135deg, #FF6B9D, #A855F7)' }}
        >
          {t('noNetwork_retry', { defaultValue: '重新尝试' })}
        </button>
      </div>
    </div>
  );
}
